import type { ProjectInquiryValues, ProjectType } from './projectInquirySchema';

const projectTypeLabels: Record<ProjectType, string> = {
  'business-website': 'Business Website',
  'corporate-website': 'Corporate Website',
  'b2b-catalogue-rfq': 'B2B Catalogue / RFQ',
  'website-redesign': 'Website Redesign',
  'landing-page': 'Landing Page',
  'not-sure': 'Not sure yet',
};

export function getProjectTypeLabel(type: ProjectType) {
  return projectTypeLabels[type];
}

export function buildFallbackMessage(values: ProjectInquiryValues) {
  const lines = [
    `Name: ${values.name.trim()}`,
    values.business_name.trim() ? `Business / Company name: ${values.business_name.trim()}` : '',
    `Email: ${values.email.trim()}`,
    `Country: ${values.country.trim()}`,
    `Project type: ${projectTypeLabels[values.project_type]}`,
    values.current_website.trim() ? `Current website: ${values.current_website.trim()}` : '',
    values.project_details.trim() ? `Project details: ${values.project_details.trim()}` : '',
    `Free preview requested: ${values.free_preview_requested ? 'Yes' : 'No'}`,
  ];
  return lines.filter(Boolean).join('\n');
}

export function buildMailto(email: string, values: ProjectInquiryValues) {
  const businessName = values.business_name.trim();
  const subject = `Website project inquiry${businessName ? ` — ${businessName}` : ''}`;
  return `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(buildFallbackMessage(values))}`;
}
